import { customAlphabet } from 'nanoid'

const nanoid = customAlphabet(
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
)
/**
 * @param {string} baseName The string to prepend
 * @param {number} [idLength] The number of random characters to add after prefix
 * @returns {string} The generated ID
 */

export const createId = (baseName, idLength) =>
  `${baseName}_${nanoid(idLength || 14)}`
